import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Prompt } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { Col, Row, Collapse, Button, Form, Input, Modal } from 'antd';
import { trim, capitalize, get } from 'lodash';
import { CaretRightFilled, ExclamationCircleOutlined } from '@ant-design/icons';
//Components
import Wait4Me from '../../../components/Wait4Me';
import BreadCrumb from '../../../components/BreadCrumb';
import NoDataToDisplay from '../../../components/NoDataToDisplay';
import NSDeployToProductionTopPannel from './components/NSDeployToProductionTopPannel';
import MatchingConfigs from './components/MatchingConfigs';
//Actions
import { getNSRunInstanceSummaryData } from '../../../redux/actions/ns/runInstance';
import { getNSGlobalSettingsPageInfo } from '../../../redux/actions/settings';
import { postCreateTicketForChampion } from '../../../redux/actions/ns/tickets';
import {
  getMatchingConfigParametersData,
  getNSMatchingConfigRiskIndicatorparameters
} from '../../../redux/actions/ns/matchingConfig';

import style from './index.scss';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../pages/constants/globalConstants';
import { RIModuleSourceIDs, RIModuleTypes } from './constants';
import { MODULE_SOURCEID_MAPPING } from '../../../util/GlobalConstant';
import { fetchAMLSAlertLevel } from '../../../redux/actions/common';
const { Panel } = Collapse;
const { confirm } = Modal;

// const [form] = Form.useForm();

export class DeployToProduction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: '0',
      valuesChanged: false,
      key: 0,
      formState: {
        values: { name: '' },
        errors: { name: '' }
      }
    };
  }

  handleWindowBeforeUnload = (e) => {
    const confirmationMessage =
      'HAHA Changes you made may not be saved Promote to Champion.';
    e.returnValue = confirmationMessage;
    return confirmationMessage;
  };

  observeElement = (elem) => {
    let resizeObserver = new ResizeObserver(() => {
      this.setState({ key: Math.random() });
    });

    resizeObserver.observe(elem);
  };

  componentDidMount() {
    const { apiActions, match, authentication, alertLevels } = this.props;

    const sourceId =
      MODULE_SOURCEID_MAPPING[
        get(authentication, 'currentProductLogin.moduleCode')
      ] || '';

    apiActions?.getNSRunInstanceSummaryData({
      id: match?.params?.id,
      sourceId
    });
    apiActions?.getNSGlobalSettingsPageInfo({
      pageId: 'NS_IAD_RUN_INSTANCE_SUMMARY'
    });

    if (!alertLevels?.length) {
      apiActions?.fetchAMLSAlertLevel();
    }

    const element = document.getElementById('__deploy__in__production__');
    element && this.observeElement(element);
    window.addEventListener('beforeunload', this.handleWindowBeforeUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleWindowBeforeUnload);
  }

  getGSConfig = (q) => {
    const { settings } = this.props;
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  onChampionNameChangeHanlder = (e) => {
    const { name, value, min, max } = e.target;
    let error = '';

    if (!!value && !/^[\p{L}\p{N}\p{M}]/u.test(value)) {
      // for space and special characters in starting of string
      error = capitalize(
        `${name} cannot start with space or special characters`
      );
    } else if (!!value && !/^[\p{L}\p{N}\p{M}\s\-_]*$/u.test(value)) {
      // for Regex validation
      error = 'Supported special characters are _ - and space.';
    } else if (value?.length < min || value?.length > max) {
      // for Regex validation
      error = capitalize(`${name} must be ${min}-${max} characters.`);
    } else {
      error = '';
    }

    this.setState({
      valuesChanged: true,
      formState: {
        values: { [name]: value },
        errors: {
          [name]: error
        }
      }
    });
  };

  onChampionNameBlurHanlder = (e) => {
    const { name, value } = e.target;
    if (value.length === 0) {
      this.setState({
        valuesChanged: true,
        formState: {
          values: { [name]: value },
          errors: {
            [name]: `Please Input Champion Name.`
          }
        }
      });
    }
  };

  showCancelConfirm = () => {
    const { formState } = this.state;
    confirm({
      title: 'Do you want to cancel changes?',
      icon: <ExclamationCircleOutlined />,
      content: 'Changes done in champion name will be lost.',
      onOk: () => {
        this.setState({
          formState: {
            values: { name: '' },
            errors: { name: '' }
          }
        });
        this.props?.apiActions?.navigateTo(
          `${ROUTE_AMLS_SMART_SCREENING}/runInstance`
        );
      },
      onCancel: () => {
        this.setState({
          valuesChanged: formState?.values?.name.length > 0 ? true : false
        });
      }
    });
  };

  createTicketForPromoteToChampionHandler = () => {
    const { formState } = this.state;
    const { match, apiActions, location, runInstanceSummaryData } = this.props;
    const moduleTypeValue = get(runInstanceSummaryData, 'data.type', null);
    let moduleType = 'NS';
    if (moduleTypeValue) {
      moduleType = RIModuleTypes[moduleTypeValue];
    }
    confirm({
      title: 'Promote to Champion',
      icon: <ExclamationCircleOutlined />,
      content: (
        <>
          The Run Instance will be sent for approval for promoting it to
          Champion.
          <br />
          <br />
          Run Instance Name: <b>{location?.state?.name || '--'}</b>
          <br />
          <br />
          Run Instance Module: <b>{moduleType}</b>
        </>
      ),
      okText: 'Confirm',
      onOk: () => {
        this.setState({ valuesChanged: false }, () => {
          const param = {
            requestType: 'PromoteChampion',
            challengerId: match?.params?.id,
            challengerName: formState.values.name,
            sourceId: RIModuleSourceIDs[moduleTypeValue]
          };
          apiActions?.postCreateTicketForChampion(param);
        });
      },
      onCancel: () => {
        console.log('Cancel');
      }
    });
  };

  render() {
    const { navigateTo } = this.props.apiActions;
    const {
      runInstanceSummaryData,
      settings,
      tickets,
      tunningParameter,
      location,
      apiActions,
      riskIndicators,
      alertLevels
    } = this.props;
    const { activeKey, formState, valuesChanged } = this.state;
    const moduleTypeValue = get(runInstanceSummaryData, 'data.type', null);
    //when user has added something than we'll show prompt **pending**

    return (
      <Row id="__deploy__in__production__">
        <Prompt
          when={valuesChanged}
          message={(location) => {
            return location.pathname.startsWith('/login')
              ? true
              : `Changes you made may not be saved.`;
          }}
        />
        <Col span={24}>
          <div className={style.wrapper}>
            {settings?.nsSetting?.isLoading ||
            runInstanceSummaryData?.isLoading ? (
              <div className={style.loadingWrapper}>
                <Wait4Me />
              </div>
            ) : (
              <React.Fragment>
                <div className={style.head}>
                  <BreadCrumb
                    crumbs={[
                      {
                        label: 'Run Instance',
                        linkTo: `${ROUTE_AMLS_SMART_SCREENING}/runInstance?tab=1`
                      },
                      { label: 'Deploy In Production' }
                    ]}
                  />
                  {runInstanceSummaryData.error === null ? (
                    <NSDeployToProductionTopPannel
                      GS={this.getGSConfig({
                        widgetGroupId: 'NS_IAD_RUN_INSTANCE_SUMMARY_PANEL',
                        widgetId: 'NS_IAD_RUN_INSTANCE_SUMMARY_PANEL'
                      })}
                      navigateTo={navigateTo}
                      data={{
                        ...location?.state,
                        alertLevels: runInstanceSummaryData?.data?.alertLevels,
                        type: runInstanceSummaryData?.data.type
                      }}
                      alertLevels={alertLevels}
                    />
                  ) : (
                    <div className={style.noDataToDisplayWrapper}>
                      <NoDataToDisplay />
                    </div>
                  )}
                </div>
                {runInstanceSummaryData.error === null && (
                  <React.Fragment>
                    <div className={style.deployToProductionDetailBody}>
                      <h4>Configuration</h4>
                      <Form layout="vertical">
                        <Form.Item label="Champion Name" required>
                          <Input
                            name="name"
                            id={'championName-input'}
                            title=""
                            value={formState.values.name}
                            placeholder="Please enter a champion name"
                            style={{ width: 250 }}
                            onChange={this.onChampionNameChangeHanlder}
                            onBlur={this.onChampionNameBlurHanlder}
                            autoComplete="off"
                            required={true}
                            min={3}
                            max={25}
                          />
                          {formState.errors.name !== '' && (
                            <p className={style.errorMessage}>
                              {formState.errors.name}
                            </p>
                          )}
                        </Form.Item>
                      </Form>
                      {/*                
                        {moduleTypeValue !== 'RS' && (
                          <Panel
                            header={`View Watchlist (${runInstanceSummaryData?.data?.watchlist?.length})`}
                            key="1">
                            <WatchAndWhitelistTable
                              GS={this.getGSConfig({
                                widgetGroupId:
                                  'NS_IAD_RUN_INSTANCE_SUMMARY_DETAILS',
                                widgetId:
                                  'NS_IAD_RUN_INSTANCE_WATCHLIST_DETAILS'
                              })}
                              tableData={{
                                isLoading: runInstanceSummaryData?.isLoading,
                                data: runInstanceSummaryData?.data?.watchlist
                              }}
                              hasRowSelection={false}
                              hasPagination={false}
                            />
                          </Panel>
                        )}

                        <Panel
                          header={`View Whitelist (${runInstanceSummaryData?.data?.whitelist?.length})`}
                          key="2">
                          <WatchAndWhitelistTable
                            GS={this.getGSConfig({
                              widgetGroupId:
                                'NS_IAD_RUN_INSTANCE_SUMMARY_DETAILS',
                              widgetId: 'NS_IAD_RUN_INSTANCE_WHITELIST_DETAILS'
                            })}
                            tableData={{
                              isLoading: runInstanceSummaryData?.isLoading,
                              data: runInstanceSummaryData?.data?.whitelist
                            }}
                            hasRowSelection={false}
                            hasPagination={false}
                          />
                        </Panel> */}
                      <Collapse
                        defaultActiveKey={['1', '2', '3']}
                        ghost
                        accordion={false}
                        expandIcon={() => <CaretRightFilled />}>
                        <Panel
                          header={`View Matching Configurations (${runInstanceSummaryData?.data?.matchingConfigs?.length})`}
                          key="3">
                          {runInstanceSummaryData?.data !== null && (
                            <MatchingConfigs
                              matchingConfigs={
                                runInstanceSummaryData?.data?.matchingConfigs
                              }
                              tunningParameter={tunningParameter}
                              activeKey={activeKey}
                              setActiveKey={(key) =>
                                this.setState({ activeKey: key })
                              }
                              getMatchingConfigParameters={
                                apiActions.getMatchingConfigParametersData
                              }
                              getMatchingConfigRiskIndicators={
                                apiActions.getNSMatchingConfigRiskIndicatorparameters
                              }
                              currentModule={RIModuleSourceIDs[moduleTypeValue]}
                              riskIndicators={riskIndicators}
                            />
                          )}
                        </Panel>
                      </Collapse>
                    </div>
                    <div className={style.deployToProductionFooter}>
                      <Button
                        id="deployToProduction_cancelBtn"
                        onClick={() => {
                          this.setState({ valuesChanged: false });
                          this.showCancelConfirm();
                        }}>
                        Cancel
                      </Button>
                      <Button
                        id="deployToProduction_saveBtn"
                        type="primary"
                        disabled={
                          formState.errors.name !== '' ||
                          formState.values.name.length === 0
                        }
                        loading={tickets?.isLoading}
                        onClick={this.createTicketForPromoteToChampionHandler}>
                        Promote to Champion
                      </Button>
                    </div>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </div>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    settings: state.settings,
    runInstanceSummaryData: state.nsRunInstanceConfig.runInstanceSummary,
    tunningParameter: state.nsMatchingConfig.matchingConfigurationParameters,
    tickets: state.nsTickets.createTicket,
    riskIndicators: state.nsMatchingConfig.matchingConfigurationRiskParameters,
    authentication: state.authentication,
    alertLevels: state.amlsCommon.alertLevelConfigs.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path, state) => push(path, state),
        getNSGlobalSettingsPageInfo,
        getNSRunInstanceSummaryData,
        postCreateTicketForChampion,
        getMatchingConfigParametersData,
        getNSMatchingConfigRiskIndicatorparameters,
        fetchAMLSAlertLevel
      },
      dispatch
    )
  };
}

DeployToProduction.propTypes = {
  apiActions: PropTypes.shape({
    navigateTo: PropTypes.func.isRequired,
    getNSGlobalSettingsPageInfo: PropTypes.func,
    getNSRunInstanceSummaryData: PropTypes.func,
    postCreateTicketForChampion: PropTypes.func
  }).isRequired,
  settings: PropTypes.object.isRequired,
  tickets: PropTypes.object.isRequired,
  runInstanceSummaryData: PropTypes.object,
  tunningParameter: PropTypes.object,
  match: PropTypes.object,
  location: PropTypes.object,
  authentication: PropTypes.object,
  alertLevels: PropTypes.array
};

export default connect(mapStateToProps, mapDispatchToProps)(DeployToProduction);
